import React from "react";
import { Search } from "lucide-react";

const InitialState = () => (
  <div className="flex flex-col items-center justify-center py-12 text-center">
    <div className="rounded-full bg-muted p-6 mb-4">
      <Search className="h-12 w-12 text-muted-foreground opacity-50" />
    </div>
    <h3 className="text-lg font-semibold mb-2">Search for customers</h3>
    <p className="text-sm text-muted-foreground max-w-sm">
      Enter at least 3 characters to start searching for customers by name,
      email, or phone number.
    </p>
  </div>
);

export default React.memo(InitialState);
